import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';
import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const scheduledEmailsSlice = createAppSlice({
  name: 'scheduledEmails',
  initialState,
  reducers,
});

export const {
  createScheduledEmail,
  loadEventScheduledEmails,
  loadChannelScheduledEmails,
  setActiveEmail,
  clearActiveEmail,
  patchScheduledEmailFields,
  patchScheduledEmailCustomizations,
  updateScheduledEmail,
  deleteScheduledEmail,
} = scheduledEmailsSlice.actions;

export default scheduledEmailsSlice.reducer;
